var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('awsui-v-multiselect',{attrs:{"enable-filtering":true,"options":_vm._f("servicesToAutocomplete")(_vm.items)},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})
}
var staticRenderFns = []

export { render, staticRenderFns }